import {ProtocolTypeEnum} from "../../enums/registry/ProtocolTypeEnum";
import {AcquisitionCronFrequencyEnum} from "../../enums/registry/AcquisitionCronFrequencyEnum";
import {SendingCronFrequencyEnum} from "../../enums/registry/SendingCronFrequencyEnum";

// Outcome of the draft-vs-official comparison, computed at read time (never persisted as
// "true" state, recalculated on every read): CREATED if the row is DRAFTED (never confirmed),
// UPDATED if the row is CREATED but one or more draft fields differ from the current official
// value. No value (undefined) if the draft matches the official row.
export enum ChangeTypeEnum {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
}

export class MetricInstanceDraftDTO {
  id?: number;
  metricId!: number;
  selected!: boolean;
  name?: string;
  divider?: number;
  decimalDigits?: number;
  transportConfiguration?: any;
  dataUnitId?: number;
  wm2eOriginType?: string;
  wm2eOriginId?: number;
  wm2eOrigin?: Wm2eOriginDTO;

  // Output only, computed at runtime: see ChangeTypeEnum.
  changeType?: ChangeTypeEnum;
}

export class Wm2eOriginDTO {

  id?: number;
  name?: string;
  partitionId?: number;
  partitionName?: string;
  gatewayId?: number;
  gatewayName?: string;
  deviceId?: number;
  deviceName?: string;
  metricGroupInstanceId?: number;
  metricGroupInstanceName?: string;
}

export class MetricGroupInstanceDraftDTO {
  id?: number;
  metricGroupId!: number;
  name?: string;
  metricOffset?: number;
  transportConfiguration?: any;
  isWritableOnEdge!: boolean;

  // Serialized by name, not by the numeric DeviceAlarmStatusEnum value.
  alarmStatus?: 'ONLINE' | 'OFFLINE' | 'WARNING';

  metrics: MetricInstanceDraftDTO[] = [];

  // Output only, computed at runtime: see ChangeTypeEnum.
  changeType?: ChangeTypeEnum;
}

export class DeviceDraftDTO {
  id?: number;
  name!: string;
  typeId!: number;
  transportConfiguration?: any;
  acquisitionCron!: AcquisitionCronFrequencyEnum;
  alarmStatus?: number;

  // Overrides
  modelName?: string;
  label?: string | null;
  partNumber?: string;
  protocolType?: ProtocolTypeEnum;
  manufacturerId?: number;
  modbusWritePauseMillis?: number;

  // Independent of the pending-config draft flow: unlike the other override fields above,
  // writing this is applied immediately server-side regardless of the device's
  // DRAFTED/CREATED state or whether the draft is ever confirmed/sent to the gateway.
  // Null on creation. If null when saving, the backend leaves the current value untouched.
  defaultType?: number;

  metricGroupInstances: MetricGroupInstanceDraftDTO[] = [];

  // Output only, computed at runtime: see ChangeTypeEnum.
  changeType?: ChangeTypeEnum;

  // Pending, unconfirmed delete: set by cancelDevicePendingConfig on an already official
  // (CREATED) device instead of dropping it from the draft, so it stays visible until the
  // draft is confirmed. When true the device's metricGroupInstances no longer count.
  pendingDelete?: boolean;
}

/**
 * Draft block for the gateway own fields (KETON-166). Absent when the draft only proposes
 * device changes. Only name/typeId/sendingCron are applied to reg_gateway on confirm;
 * macAddress/online are just carried along in the payload, never compared nor applied.
 */
export class GatewayDraftDTO {
  name!: string;
  typeId!: number;
  sendingCron!: SendingCronFrequencyEnum;
  macAddress?: string;
  online?: boolean;

  // Output only, computed at runtime: see ChangeTypeEnum (never DELETED for the gateway).
  changeType?: ChangeTypeEnum;
}

export class GatewayPendingConfigPayloadDTO {
  gateway?: GatewayDraftDTO;
  devices: DeviceDraftDTO[] = [];
}
